var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Store } from 'bernie-plugin-mobx';
import { AuthenticationState } from 'bernie-context';
import { action, observable, computed, runInAction } from 'mobx';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { LoyaltySource } from '../source/loyalty-source';
/**
 * MobX store that houses data neccessary to display the Global Header/Footer
 */
var GlobalComponentsContextStore = /** @class */ (function (_super) {
    __extends(GlobalComponentsContextStore, _super);
    function GlobalComponentsContextStore(state, logger) {
        if (state === void 0) { state = {}; }
        var _this = _super.call(this, state, logger) || this;
        _this.loyaltySource = new LoyaltySource();
        return _this;
    }
    GlobalComponentsContextStore.prototype.fetchLoyalty = function (context) {
        var _this = this;
        var user = context && context.user;
        var authState = user && user.authState;
        var userAnonymous = !authState || authState === AuthenticationState.ANONYMOUS;
        if (!userAnonymous && !this.header.useSharedUIHeader) {
            return this.loyaltySource
                .fetch({ context: context, tuid: this.tuid })
                .then(function (data) {
                runInAction(function () {
                    if (data && data.loyalty) {
                        Object.assign(_this, data);
                    }
                });
            })
                .catch(function (error) {
                if (_this.logger) {
                    _this.logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'LOYALTY_FETCH_ERROR'), error);
                }
                return {};
            });
        }
        return Promise.resolve();
    };
    Object.defineProperty(GlobalComponentsContextStore.prototype, "loyaltyTierString", {
        get: function () {
            return this.loyalty && this.loyalty.tierString ? this.loyalty.tierString : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalComponentsContextStore.prototype, "accountInfoString", {
        get: function () {
            return this.loyalty && this.loyalty.accountInfoString ? this.loyalty.accountInfoString : null;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * {@inheritDoc}
     */
    GlobalComponentsContextStore.prototype.hydrate = function (data) {
        Object.assign(this, data);
    };
    __decorate([
        observable
    ], GlobalComponentsContextStore.prototype, "header", void 0);
    __decorate([
        observable
    ], GlobalComponentsContextStore.prototype, "footer", void 0);
    __decorate([
        observable
    ], GlobalComponentsContextStore.prototype, "isSua", void 0);
    __decorate([
        observable
    ], GlobalComponentsContextStore.prototype, "firstName", void 0);
    __decorate([
        observable
    ], GlobalComponentsContextStore.prototype, "localeOptions", void 0);
    __decorate([
        observable
    ], GlobalComponentsContextStore.prototype, "tuid", void 0);
    __decorate([
        observable
    ], GlobalComponentsContextStore.prototype, "loyalty", void 0);
    __decorate([
        action
    ], GlobalComponentsContextStore.prototype, "fetchLoyalty", null);
    __decorate([
        computed
    ], GlobalComponentsContextStore.prototype, "loyaltyTierString", null);
    __decorate([
        computed
    ], GlobalComponentsContextStore.prototype, "accountInfoString", null);
    __decorate([
        action
    ], GlobalComponentsContextStore.prototype, "hydrate", null);
    return GlobalComponentsContextStore;
}(Store));
export { GlobalComponentsContextStore };
//# sourceMappingURL=global-controls-store.js.map